// assets/header-big.js
// メニューボタンでドロワーを開閉

document.addEventListener("DOMContentLoaded", function () {
  var header = document.querySelector("[data-header-big]");
  if (!header) return;

  var toggleBtn = header.querySelector("[data-header-big-menu-toggle]");
  var drawer = header.querySelector("[data-header-big-drawer]");
  var closeBtn = header.querySelector("[data-header-big-menu-close]");

  if (!toggleBtn || !drawer) return;

  function openDrawer() {
    drawer.classList.add("HeaderBig__Drawer--open");
    drawer.setAttribute("aria-hidden", "false");
    toggleBtn.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("is-HeaderBig-drawer-open");
  }

  function closeDrawer() {
    drawer.classList.remove("HeaderBig__Drawer--open");
    drawer.setAttribute("aria-hidden", "true");
    toggleBtn.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("is-HeaderBig-drawer-open");
  }

  toggleBtn.addEventListener("click", function () {
    if (drawer.classList.contains("HeaderBig__Drawer--open")) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      closeDrawer();
    });
  }

  // オーバーレイ背景クリックでも閉じる
  drawer.addEventListener("click", function (event) {
    if (event.target === drawer) {
      closeDrawer();
    }
  });

  // ESCキーで閉じる
  document.addEventListener("keyup", function (event) {
    if (event.key === "Escape") {
      closeDrawer();
    }
  });
});

// =========================================================
// Mobile Mega Menu (Panel Switch)
// =========================================================
document.addEventListener("DOMContentLoaded", () => {
  const triggers = document.querySelectorAll("[data-mobile-mega-trigger]");
  const backs = document.querySelectorAll("[data-mobile-mega-back]");

  triggers.forEach(btn => {
    btn.addEventListener("click", () => {
      const target = document.getElementById(btn.dataset.target);
      if (target) {
        target.removeAttribute("hidden");
      }
    });
  });

  backs.forEach(btn => {
    btn.addEventListener("click", () => {
      const target = document.getElementById(btn.dataset.target);
      if (target) {
        target.setAttribute("hidden", "true");
      }
    });
  });
});